const retentions = [
	{
		code: '303',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Honorarios, comisiones y dietas a personas naturales',
		COMP: '2.1.1.08.006',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '304',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios / Predomina el intelecto',
		COMP: '2.1.1.08.007',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '305',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Honorarios a extranjeros por servicios ocasionales',
		COMP: '',
		VENTA: '',
	},
	{
		code: '306',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por compras locales de materia prima',
		COMP: '',
		VENTA: '',
	},
	{
		code: '307',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios / Predominan mano de obra',
		COMP: '2.1.1.08.008',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '308',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios / Entre sociedades',
		COMP: '2.1.1.08.009',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '309',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios / Publicidad y comunicación',
		COMP: '2.1.1.08.010',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '310',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios / Transporte privado de pasajeros o servicio público',
		COMP: '2.1.1.08.011',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '311',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por pagos a través de liquidación de compra',
		COMP: '',
		VENTA: '',
	},
	{
		code: '312',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Transferencia de bienes muebles de naturaleza corporal',
		COMP: '2.1.1.08.012',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '313',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por concepto de servicio de transporte privado de pasajeros o servicio publico o privado de carga',
		COMP: '',
		VENTA: '',
	},
	{
		code: '314',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por regalías, derechos de autor, marcas, patentes y similares',
		COMP: '',
		VENTA: '',
	},
	{
		code: '315',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por remuneraciones a deportistas, entrenadores, cuerpo técnico, árbitros y artistas residentes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '316',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por pagos realizados a notarios y registradores de la propiedad o mercantiles',
		COMP: '',
		VENTA: '',
	},
	{
		code: '317',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por comisiones pagadas a sociedades',
		COMP: '',
		VENTA: '',
	},
	{
		code: '318',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por promoción y publicidad',
		COMP: '',
		VENTA: '',
	},
	{
		code: '319',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por arrendamiento mercantil local',
		COMP: '',
		VENTA: '',
	},
	{
		code: '320',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por arrendamiento de bienes inmuebles de propiedad de personas naturales',
		COMP: '2.1.1.08.020',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '321',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por arrendamiento de bienes inmuebles a sociedades',
		COMP: '',
		VENTA: '',
	},
	{
		code: '322',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por seguros y reaseguros (primas y cesiones)',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323a',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Rendimientos Financieros',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323b',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: depositos en cuentas corrientes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323c',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: depositos en cuentas de ahorros',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323d',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: depositos en cuentas corrientes exentas',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323e',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: compra, cancelación o redención de mini vemos y vemos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323f',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: depositos a plazo',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323g',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: operaciones de reporto - repos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323h',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: inversiones (captaciones)',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323i',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: obligaciones',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323j',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: bonos convertibles en acciones',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323k',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros: bonos de organismos y gobiernos extranjeros',
		COMP: '',
		VENTA: '',
	},
	{
		code: '324',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por pagos o créditos en cuenta realizados por empresas emisoras de tarjetas de crédito',
		COMP: '',
		VENTA: '',
	},
	{
		code: '325',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por loterías, rifas, apuestas y similares',
		COMP: '',
		VENTA: '',
	},
	{
		code: '326',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por intereses y comisiones en operaciones de crédito entre las inst. Del sistema financiero',
		COMP: '',
		VENTA: '',
	},
	{
		code: '327',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por venta de combustibles a comercializadoras',
		COMP: '',
		VENTA: '',
	},
	{
		code: '328',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por venta de combustibles a distribuidores',
		COMP: '',
		VENTA: '',
	},
	{
		code: '329',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por otros servicios',
		COMP: '',
		VENTA: '',
	},
	{
		code: '330',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por pagos de dividendos anticipados',
		COMP: '',
		VENTA: '',
	},
	{
		code: '331',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por agua, energía, luz y telecomunicaciones',
		COMP: '',
		VENTA: '',
	},
	{
		code: '332',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras compras de bienes y servicios no sujetas a retención',
		COMP: '',
		VENTA: '',
	},
	{
		code: '401',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Con convenio de doble tributación',
		COMP: '',
		VENTA: '',
	},
	{
		code: '403',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación intereses y costos financieros por financiamiento de proveedores',
		COMP: '',
		VENTA: '',
	},
	{
		code: '405',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación intereses de créditos externos registrados en el ve (en la cuanto',
		COMP: '',
		VENTA: '',
	},
	{
		code: '407',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación intereses de créditos externos no registrados en el ve',
		COMP: '',
		VENTA: '',
	},
	{
		code: '409',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación comisiones por exportaciones',
		COMP: '',
		VENTA: '',
	},
	{
		code: '411',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación comisiones pagadas para la promoción del turismo receptivo',
		COMP: '',
		VENTA: '',
	},
	{
		code: '413',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación el 4% de las primas de cesión o reaseguros contratados con empresa',
		COMP: '',
		VENTA: '',
	},
	{
		code: '415',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación el 10% de los pagos efectuados por las agencias internacionales de',
		COMP: '',
		VENTA: '',
	},
	{
		code: '417',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación el 10% del valor de los contratos de fletamento de naves para empr',
		COMP: '',
		VENTA: '',
	},
	{
		code: '419',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación el 15% de los pagos efectuados por productoras y distribuidoras de',
		COMP: '',
		VENTA: '',
	},
	{
		code: '421',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Sin convenio de doble tributación por otros conceptos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '423',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Arrendamiento mercantil internacional por pago de intereses (cuando supera la tasa autorizada por el',
		COMP: '',
		VENTA: '',
	},
	{
		code: '425',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Arrendamiento mercantil internacional cuando no se ejerce la opción de compra (sobre la depreciación',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros',
		COMP: '',
		VENTA: '',
	},
	{
		code: '333',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Convenio de débito o recaudación (cinta crr o ahorros)',
		COMP: '',
		VENTA: '',
	},
	{
		code: '334',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por Compra con Tarjetas de Crédito',
		COMP: '',
		VENTA: '',
	},
	{
		code: '340',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras Retenciones / Aplicables el 1%',
		COMP: '2.1.1.08.013',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '341',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras Retenciones / Aplicables el 2%',
		COMP: '2.1.1.08.014',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '342',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras Retenciones / Aplicables el 8%',
		COMP: '2.1.1.08.015',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '343',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras Retenciones / Aplicables el 25%',
		COMP: '2.1.1.08.016',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '304A',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Comisión y demás pagos por serv. que pred. intelecto no rel. titulo Prof.',
		COMP: '2.1.1.08.007',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '304B',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Pagos a notarios y reg. de la propiedad y mercantil',
		COMP: '',
		VENTA: '',
	},
	{
		code: '304D',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Pagos a artistas por sus actividades',
		COMP: '',
		VENTA: '',
	},
	{
		code: '304E',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Honorarios y demás pagos por Serv. Docencia',
		COMP: '',
		VENTA: '',
	},
	{
		code: '312A',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'compra de bienes agrícola, avícola, pecuario, apícola, cunicular, bioacuático y forestal',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por rendimientos financieros a P. naturales',
		COMP: '',
		VENTA: '',
	},
	{
		code: '332A',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por enajenación ocasional de acciones',
		COMP: '',
		VENTA: '',
	},
	{
		code: '332B',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Compra de Bienes Inmuebles',
		COMP: '',
		VENTA: '',
	},
	{
		code: '334',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Pago con Tarjeras de Crédito',
		COMP: '',
		VENTA: '',
	},
	{
		code: '340A',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por energía eléctrica',
		COMP: '',
		VENTA: '',
	},
	{
		code: '340B',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Actividades de construcción obra material inmueble',
		COMP: '',
		VENTA: '',
	},
	{
		code: '344',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras retenciones aplicables 2 por ciento',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323b1',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por RF: depositos Cta. Ahorros Sociedades',
		COMP: '',
		VENTA: '',
	},
	{
		code: '323b2',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Por RF: depositos Cta. Ahorros Persona Natural',
		COMP: '',
		VENTA: '',
	},
	{
		code: '332',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Otras compras de bienes y servicios no sujetas a retención',
		COMP: '',
		VENTA: '',
	},
	{
		code: '337',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Reembolso de Gasto - Compra de quien asume el gasto',
		COMP: '',
		VENTA: '',
	},
	{
		code: '345',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Dividendos personas naturales residentes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '346',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Dividendos sociedades en parases fiscales',
		COMP: '',
		VENTA: '',
	},
	{
		code: '347',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Dividendos anticipados',
		COMP: '',
		VENTA: '',
	},
	{
		code: '348',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Compra local de banano a productor',
		COMP: '',
		VENTA: '',
	},
	{
		code: '349',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Impuesto a la actividad bananera productor-exportador',
		COMP: '',
		VENTA: '',
	},
	{
		code: '500',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Rentas Inmobiliarias',
		COMP: '',
		VENTA: '',
	},
	{
		code: '502',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios Empresariales',
		COMP: '',
		VENTA: '',
	},
	{
		code: '504',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Dividendos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '506',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Intereses por Financiamiento de proveedores externos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '507',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Intereses de créditos externos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '508',
		ms_catalog_header_code: 'TABLA3.2',
		description: "Créditos de IFI's organismos y gobierno a gobierno",
		COMP: '',
		VENTA: '',
	},
	{
		code: '509',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Cánones o regalías',
		COMP: '',
		VENTA: '',
	},
	{
		code: '510',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Ganancias de capital',
		COMP: '',
		VENTA: '',
	},
	{
		code: '511',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios profesionales independientes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '512',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Servicios profesionales dependientes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '513',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Artistas y deportistas',
		COMP: '',
		VENTA: '',
	},
	{
		code: '514',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Participación de consejeros',
		COMP: '',
		VENTA: '',
	},
	{
		code: '515',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Entretenimiento Público',
		COMP: '',
		VENTA: '',
	},
	{
		code: '516',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Pensiones',
		COMP: '2.1.1.06.009',
		VENTA: '1.1.2.03.003',
	},
	{
		code: '517',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Reembolso de Gastos',
		COMP: '',
		VENTA: '',
	},
	{
		code: '518',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Funciones Públicas',
		COMP: '',
		VENTA: '',
	},
	{
		code: '519',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'Estudiantes',
		COMP: '',
		VENTA: '',
	},
	{
		code: '3440',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'RETENCIÓN 2.75%',
		COMP: '',
		VENTA: '',
	},
	{
		code: '1',
		ms_catalog_header_code: 'TABLA20',
		description: 'RETENCIÓN IVA 30%',
		COMP: '2.1.1.08.017',
		VENTA: '1.1.2.03.002',
	},
	{
		code: '2',
		ms_catalog_header_code: 'TABLA20',
		description: 'RETENCIÓN IVA 70%',
		COMP: '2.1.1.08.018',
		VENTA: '1.1.2.03.002',
	},
	{
		code: '3',
		ms_catalog_header_code: 'TABLA20',
		description: 'RETENCIÓN IVA 100%',
		COMP: '2.1.1.08.019',
		VENTA: '1.1.2.03.002',
	},
	{
		code: '303A',
		ms_catalog_header_code: 'TABLA3.2',
		description: 'HONORARIOS PROFESIONALES EMPRESAS',
		COMP: '',
		VENTA: '',
	},
];

export default retentions;



// WEBPACK FOOTER //
// ./src/pages/accounting-plans/export-retentions.js